import React, { useState } from "react";
import { useSelector } from "react-redux";
// utils
  import C from "Constants";
import { UTILS } from "utils";
// components
import WithLoading from "components/Hoc/WithLoading";
import { PageHeaderV2 } from "components/PageHeader";
import * as CommonCheckoutUI from "components/checkout/index";
import WithTransparentSpinner from "components/Hoc/WithTransparentSpinner";
//hooks
import * as commonHooks from "hooks";
import useSuccesOrder from "features/hooks/useSuccesOrder";
import usePaymentHelper from "features/payment-helpers/usePaymentHelper";
import usePlaceOrderHelper from "features/payment-helpers/usePlaceOrderHelper";
//features
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";
import CheckoutErrorModal from "./Modals";

const PaymentOptions = ({setIsPayementOptionPage}) => {

  const redirectLink = C.PAYMENT_RDX_LINKS.OUTLET_BASE;
  const { goToSettings, goToLogin } = useDelivertPickupFn();
  const { currentPaymentMethod } = useSelector((state) => state.AppReducer);
  const handleSuceessOrderRoute = useSuccesOrder();
  const { integrationsByName } = commonHooks.useBrandLosgisticIntegrations();
  const { selectedPaymentType } = useSelector(
    (state) => state.PaymentMethodReducer
  );
  const {
    placeOrder,
    cardProcessing,
    isLoading,
    captureCheckoutDotComPayment,
    setcardProcessing,
  } = usePaymentHelper(redirectLink, handleSuceessOrderRoute);
  const { outlet_based_place_order } = usePlaceOrderHelper(
    handleSuceessOrderRoute
  );

  const { orderType } = useSelector((state) => state.AppReducer);

  const { cart, cartTotal, orderGrossAmount } = useSelector(
    (state) => state.cart
  );
  const { outletBasedSelectedStoreArea, selectedStore, selectedPayment } =
    useSelector((state) => state.store);


  const [resetSelectedType, setResetSelectedType] = useState(null);

  const validateOrderShipping = () => {
    const { errors, isValid, obj } = UTILS.validateOutletOrderObject();
    return {
      errors,
      isValid,
      obj,
    };
  };

  return (
    <WithLoading loading={isLoading}>
      <div className="checkout-page min-h-app-height store-page-popup">
        <PageHeaderV2
          pageTitle={"Payment Options"}
          authClick={goToLogin}
          userClick={goToSettings}
          onGoBack={()=>setIsPayementOptionPage(false)}
          containerStyleProps={{
            style: {
              zIndex: 0,
              position: "relative",
              top: 0,
              backgroundColor: "white",
              width: "98.9%",
              margin: "0 auto",
            },
          }}
          headerStyleProps={{
            className: "p-4",
          }}
        />
        <div className="p-4 flex flex-col gap-4 relative">
          <CommonCheckoutUI.CheckoutPaymentMethodN
            paymentOptions={
              orderType?.serviceType === C.SERVICE_TYPE.DELIVERY
                ? selectedStore?.paymentOptions
                : selectedStore?.pickupPaymentOptions
            }
            handleSuceessOrderRoute={handleSuceessOrderRoute}
            setcardProcessing={setcardProcessing}
            resetSelectedTypeProps={{
              selectedPaymentType: resetSelectedType,
              resetSelectedType: () => setResetSelectedType(null),
            }}
          >
            <CommonCheckoutUI.SavedCardsList
              {...{
                integrationsByName,
                captureCheckoutDotComPayment,
              }}
            />
            {selectedPayment?.paymentType === C.CREDIT_CARD &&
            selectedPaymentType === C.WALLET.NEW_CARD ? (
              <CommonCheckoutUI.CardWidgets
                {...{
                  integrationsByName,
                  captureCheckoutDotComPayment,
                  redirectLink: redirectLink,
                  setcardProcessing: setcardProcessing,
                  handleSuceessOrderRoute: handleSuceessOrderRoute,
                }}
                isNewUI
              />
            ) : null}
          </CommonCheckoutUI.CheckoutPaymentMethodN>
        </div>
        {(selectedPaymentType === C.WALLET.NEW_CARD &&
          [C.PAYBY, C.AFS_PAYMENT].includes(currentPaymentMethod)) ||
        cart?.length <= 0 ? (
          <></>
        ) : (
          <CommonCheckoutUI.FooterWithWallet
            storePageUrl={`/store/store-detail`}
            minOrder={outletBasedSelectedStoreArea?.minOrder || 0}
            placeORder={outlet_based_place_order}
            Place_Order={placeOrder}
            disabled={!selectedPaymentType}
            text={"Place Order"}
            // disabled={cart?.length === 0 || (orderType?.serviceType === C.SERVICE_TYPE.PICKUP && !pickupVehicleInfo )}
            {...{
              outletBasedSelectedStoreArea,
              cartTotal,
              integrationsByName,
              selectedStore,
              cardProcessing,
              validateOrderShipping,
              orderGrossAmount,
              disabled: !selectedPaymentType,
            }}
          />
        )}
        <CheckoutErrorModal
          selectedPaymentType={selectedPaymentType}
          resetState={(val) => setResetSelectedType(val)}
        />
      </div>
      <WithTransparentSpinner loading={cardProcessing || isLoading} />
    </WithLoading>
  );
};

export default PaymentOptions;
